<template>
  <div
    id="RankingReport"
    data-test="rankingReport"
  >
    <div class="table__wrapper">
      <table
        data-test="table"
        class="table is-bordered is-striped center-table is-full-width"
      >
        <tr>
          <th
            v-for="field in fields"
            :key="field.label"
          >
            {{ field.label }}
          </th>
        </tr>
        <tr
          v-for="item in arrayOfRankings"
          :key="item.keyword"
        >
          <td
            v-for="field in fields"
            :key="field.key"
          >
            <span v-if="item[field.key] && item[field.key].rank">

              <font-awesome-layers class="fa-fw">
                <font-awesome-icon
                  icon="circle"
                  class="wdc-blue"
                />
                <font-awesome-layers-text
                  :value="rankChange(item[field.key])"
                  class="icon-white"
                  transform="up-1"
                />
              </font-awesome-layers>
              <span class="rank-change">{{ rankChange(item[field.key]) }}</span>
            </span>
            <span v-else>
              {{ item[field.key] }}
            </span>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
// import TrendArrow from '@/components/Shared/TrendArrow'
// import { mapState } from 'vuex'

export default {
  name: 'BaseFullRankingReport',
  components: {
    // arrow: TrendArrow,
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },

  data () {
    return {
      fullRankingReport: {},
      fields: [
        {
          key: 'keyword',
          label: this.$t('seo_service.full_rank.table.keywords')
        },
        {
          key: 'google',
          label: this.$t('seo_service.full_rank.table.google')
        },
        {
          key: 'google-mobile',
          label: this.$t('seo_service.full_rank.table.mobile')
        },
        {
          key: 'google-places',
          label: this.$t('seo_service.full_rank.table.maps')
        },
        {
          key: 'bing',
          label: this.$t('seo_service.full_rank.table.bing')
        },
        {
          key: 'bing-local',
          label: this.$t('seo_service.full_rank.table.bing_local')
        }
      ]
    }
  },

  computed: {
    arrayOfRankings () {
      return Object.keys(this.data).map(keyword => ({
        keyword,
        ...Object.keys(this.data[keyword]).reduce((acc, engine) => {
          const eng = this.data[keyword] && this.data[keyword][engine]
          return {
            ...acc,
            [engine]: {
              rank: eng && eng[0] && eng[0].rank,
              last: eng && eng[0] && eng[0].last
            }
          }
        }, {})
      }))
    }
  },

  methods: {
    rankChange ({ rank, last }) {
      return rank != null && last != null
        ? rank - last
        : 0
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../../../sass/_variables.scss';
.center-table {
  th {
    text-align: center;
    vertical-align: middle;
  }
  td {
    text-align: center;
    vertical-align: middle;
  }
}
.table__wrapper {
  overflow-x: auto;
  margin: -1.6rem;
}

  // .fa-stack-2x {
  //   height: 1em;
  //   width: 1em;
  // }
  .rank-change {
    margin-left: 10px;
  }
  .wdc-blue {
    color: var(--base-blue);
    font-size: 1.3em;
  }
  .icon-white {
    color: #ffffff;
    // font-size: 12px;
  }

</style>
